module.exports = __webpack_public_path__ + "static/media/DSC09604.ce83918a.jpg";